import ReactGA from 'react-ga';
import Header from './components/common-header/Header';
import Footer from './components/common-footer/Footer';
import './assets/sass/App.scss';
import heroImg from './assets/img/hero.png';
import doctorImg from './assets/img/vuk-milojkovic.png';
import image1 from './assets/img/img1.png';
import image2 from './assets/img/img2.png';
import image3 from './assets/img/img3.png';
import basfImg from './assets/img/basf.png';
import { useEffect, useState } from 'react';
ReactGA.initialize('UA-79459204-76');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  const [scroll, setScroll] = useState(false);
  const sendEvent = (url) => {
    ReactGA.event({
      category: 'User',
      action: `clicked on ${url}`
    });
    // window.open(url);
  };
  useEffect(() => {
    document.onscroll = () => {
      if (!scroll) {
        ReactGA.event({
          category: 'User',
          action: `Scrolled`
        });
        setScroll(true);
      }
    };
  }, [scroll]);
  return (
    <div className="app">
      <Header clientName={'BASF'} />
      <section className="hero-section">
        <div className="hero-title">
          <h1>Paving the Road for Electric Mobility in North America</h1>
        </div>
        <div style={{ backgroundImage: heroImg }} className="hero"></div>
      </section>
      <section>
        <p>
          The acceptance, adoption, and availability of electric vehicles are well underway. As U.S.
          automakers transition away from internal combustion engines and toward battery-powered
          motors, U.S.-based OEMs must go the extra mile to deliver on the promise of an
          all-electric future and a more sustainable auto industry. In particular, the makers of
          battery components are tasked with quickly scaling domestic manufacturing capability in
          addition to working on increasing driving range and reliability—all while keeping costs
          low. So, building out the supply chain is critical to that reality.{' '}
        </p>
        <p>
          {' '}
          As for the batteries themselves, they must be able to power everything from compact cars,
          to pickup trucks, delivery vans, big rigs, and even public transportation vehicles. A
          vital component to better batteries is the chemistry of cathode active materials. This is
          the focus of BASF’s effort to serve as an enabler of automotive electrification.
        </p>
      </section>

      <section className="cta-section">
        <div className="cta">
          <img
            alt="Dr Gulay Serhatkulu's Profile for Desktop"
            src={doctorImg}
            className="cta__profile-image"
          />
          <div className="cta__inner">
            <p className="cta__headliner">
              Growth is very much subject to the right performance at the right cost of electric
              vehicles and one of the key components of both is having the right chemistry for the
              cathode materials that go into their batteries.”
            </p>
            <div className="cta__profile-info">
              <img alt="Dr Gulay Serhatkulu's Profile" src={doctorImg} />
              <div>
                <p className="title">Vuk Milojkovic</p>
                <p>
                  Director of Battery Materials at BASF North America and CEO of BASF Toda America
                  LLC
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <h3>The Man Behind the Wheel</h3>
        <p>
          Central to this effort is Vuk Milojkovic, Director of Battery Materials at BASF North
          America and CEO of BASF Toda America LLC. As a BASF veteran—totaling nine roles, six
          divisions, and over 20 years of experience, Milojkovic has built his career across
          multiple functions and various businesses, with the latter half of his tenure focused on
          automotive. Among the many things on his plate, Milojkovic’s team operates the largest
          commercial-scale cathode materials manufacturing facility in North America—working with
          cell producers to deliver tailor-made materials that go into EV batteries.
        </p>
        <p>
          “Our role is to be the enabler of this transformation,” Milojkovic says. “Automotive
          companies, OEMs, have certain technical and commercial targets and want to achieve certain
          goals. But their growth is very much subject to the right performance at the right cost of
          their electric vehicles and one of the key components of both is having the right
          chemistry for the cathode materials that go into their batteries.”
        </p>
        <p>
          Milojkovic understands at a fundamental level that the battery expectations of a
          commercial truck are vastly different from that of a sports car. One vehicle might
          prioritize speed over power while other vehicles may require longer battery range for
          longer trips. These are the challenges that the right chemistry can solve. But this is
          just the tip of the iceberg when evaluating the needs of an all-electric future.
        </p>
      </section>

      <section className="cta-section">
        <div className="cta cta--text-only">
          <div className="cta__inner">
            <p className="cta__headliner">
              The cathode active materials produced by BASF are central to the performance,
              affordability, safety, and sustainability of electrified vehicles being manufactured
              today.”
            </p>
            <div className="cta__profile-info cta__profile-info--text-only">
              <div>
                <p className="title">Vuk Milojkovic</p>
                <p>
                  Director of Battery Materials at BASF North America and CEO of BASF Toda America
                  LLC
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <h3>The Foundation of an Electric Future</h3>
        <p>
          One of the biggest challenges facing “e-mobility” in the U.S. is first establishing a
          domestic EV supply chain. When auto CEOs announce that they will go all-electric, that
          signals all their partners to shift gears and start building the necessary infrastructure
          to support this new demand. This requires securing a reliable and sustainable supply of
          key raw materials while building manufacturing capabilities to process and refine them
          before they are used in the production of battery materials. Right now, the North American
          EV supply chain is in its infancy. “The easy answer is that almost none of it exists today
          here. The electric, EV supply chain is dominated by suppliers and producers outside the
          region. That's where the market has been. What you see now is the market is slowly
          evolving and being built in Europe, which is just starting here in North America.” Says
          Milojkovic.
        </p>
        <p>
          With a keen eye on the future, BASF can see that the supply chain for producing these
          batteries and putting them into cars will need to be regionally optimized if the EV goals
          in the next decade are going to be met. It is also looking to establish a reliable and
          cost-effective way to supply cathode materials to customers in North America and reduce
          risks associated with the current reliance on importing these components.{' '}
        </p>
      </section>

      <section className="photo-grid-section">
        <div className="photo-grid">
          <div>
            <img alt="Scientist examining a plastic sheet sample" src={image1} />
          </div>
          <div className="smaller-images">
            <img alt="Two Engineers Adjusting Equipment" src={image2} />
            <img alt="Two Engineers Checking Equipment" src={image3} />
          </div>
        </div>
        <div className="photo-grid-caption">
          Globally, BASF is conducting research on innovative cathode materials for high-performance
          lithium-ion batteries that make electromobility a reality. The cathode materials usually
          consist of mixed metal oxides.
        </div>
      </section>

      <section>
        <h3>Ideas That Change The Game</h3>
        <p>
          How do we get there from here? The first step is to secure and source the metals needed
          for active cathode materials immediately. Before we reach the point where demand for EVs
          outpaces production capacity, BASF and companies like it can act now to make sure that in
          five to ten years, the production of EVs doesn’t suddenly slow down because of a lack of
          battery materials. This means securing partnerships, as BASF is doing, with companies
          around the world that can derive the necessary metals sustainably.{' '}
        </p>
        <p>
          The final piece is developing battery technology for the next generation of EVs. The
          current dominant battery technology is lithium-ion. But as promising as lithium-ion
          technology is, technological needs and battery requirements will change over time and the
          push for more range at lower costs will be inevitable. This requires the right science and
          manufacturing at the right time. According to Milojkovic, “[BASF’s] portfolio of
          chemistries is well suited to move into different types of [battery] technology. We’re
          able to make this transition with the right technology and the right chemistry to support
          the next generation, whether it's solid-state [batteries] or something else.”{' '}
        </p>
        <p>
          The cathode active materials produced by BASF are central to the performance,
          affordability, safety, and sustainability of electrified vehicles being manufactured
          today. And as part of its long-term battery materials strategy, BASF continues to work
          with industry partners and the scientific community to develop innovative materials,
          processes, and technologies for current and next-generation lithium-ion batteries and
          future battery systems.{' '}
        </p>
        <p className="link-to">
          To learn more about BASF’s work on battery materials click{' '}
          <a
            href="https://www.weloveevs.basf.com/battery/en-en/"
            target="_blank"
            rel="sponsored"
            className="link-to-link"
            onClick={() => {
              sendEvent('https://www.weloveevs.basf.com/battery/en-en/');
            }}
          >
            here
          </a>
          .
        </p>
        <p className="link-to">
          <a
            className="link-to"
            href="https://www.basf.com/us/en.html"
            target="_blank"
            rel="sponsored noopener"
            onClick={() => {
              sendEvent('https://www.basf.com/us/en.html');
            }}
          >
            <img alt="BASF Logo" className="basf-logo" src={basfImg} />
          </a>
        </p>
      </section>
      <Footer />
    </div>
  );
}

export default App;
